import type { ArrendamentoResumo } from '../schemas';

function texto(value: unknown): string {
  return typeof value === 'string' || typeof value === 'number' ? String(value) : '';
}

export function imoveisDoContrato(arr: ArrendamentoResumo): Record<string, unknown>[] {
  const rows = [...(arr.imoveis ?? []), ...(arr.imovel ? [arr.imovel] : [])];
  return [...new Map(rows.map((im) => [String(im.id), im])).values()];
}

export function tituloImoveis(arr: ArrendamentoResumo): string | null {
  const nomes = imoveisDoContrato(arr).map((im) =>
    texto(im.denominacao) || (texto(im.matricula) ? `Matrícula ${texto(im.matricula)}` : `Imóvel ${texto(im.id)}`));
  if (nomes.length) return nomes.join(' / ');
  if (arr.imovel_denominacao) return arr.imovel_denominacao;
  // Objeto cadastrado pode identificar o lote mesmo sem vínculo estrutural.
  // Não usar observações de migração nem o ID global como nome do imóvel.
  const objeto = texto(arr.contrato_objeto);
  const identidade = (objeto.split(/\s+[—–]\s+matr[ií]cula|\.\s/iu)[0] ?? "").trim();
  return /lotes?\s+.+gleba\s+/iu.test(identidade) ? identidade : null;
}

export function matriculasImoveis(arr: ArrendamentoResumo): string | null {
  const matriculas = imoveisDoContrato(arr).map((im) => im.matricula).filter(Boolean).map(String);
  return matriculas.length ? matriculas.join(' / ') : arr.imovel_matricula || null;
}

export function municipiosImoveis(arr: ArrendamentoResumo): string | null {
  const locais = imoveisDoContrato(arr).filter((im) => im.municipio)
    .map((im) => `${texto(im.municipio)}${texto(im.uf) ? '/' + texto(im.uf) : ''}`);
  return locais.length ? [...new Set(locais)].join(' / ') :
    arr.imovel_municipio ? `${arr.imovel_municipio}${arr.imovel_uf ? '/' + arr.imovel_uf : ''}` : null;
}

